import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import uniqueId from "lodash/uniqueId";

import { UserContextProps, withUserContext } from "@app/user";
import { OutreachExportType } from "./enumerations";
import { OutreachDataPanelBody } from "./export-panel-body";
import { QESButton } from "@app/shared/qes-standards";
import { AccordionContainer, Accordion, Breadcrumbs, Page, PageHeader, PageHeaderRight, PageInner, PageSection } from "@app/shared";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QesIcon } from "@app/shared/icons/QESIcon";

type ExportOutreachDataProps = RouteComponentProps & UserContextProps;

interface RouteState {
  exportType: OutreachExportType
}

interface ExportOutreachDataState extends RouteState {
  reportGenerating: boolean;
}

class ExportOutreachData extends React.Component<ExportOutreachDataProps, ExportOutreachDataState> {
  private readonly panelGroupId = uniqueId("export-data-panel-group-");
  private readonly accordionId = uniqueId("accordion-");

  constructor(props: ExportOutreachDataProps) {
    super(props);
    const routeState = this.extractRouteState();

    this.state = {
      exportType: routeState.exportType,
      reportGenerating: false,
    };
  }

  public componentDidUpdate() {
    $(`#${this.panelGroupId}`).collapse({
      toggle: false,
    });
  }

  public render() {
    const breadcrumbs = ["Network Outreach", "Reports"];

    return (
      <Page documentTitle="Create Downloadable Report - Network Outreach">
        <Breadcrumbs items={breadcrumbs} />
        <PageInner>
          <PageHeader iconName={QesIcons.FontAwesome.CloudDownload} title="Create Downloadable Report" disableHR={false}>
            <PageHeaderRight>
              <div className="d-flex">
                <QESButton qesTestId="outreach-export-data_return-to-project" qesType="secondary" onClick={() => this.props.history.goBack()} className="mr-2">Return to Network Outreach</QESButton>
                <Link to='/reports' className="qes-button qes-button-primary" type="button">Reports</Link>
              </div>
            </PageHeaderRight>
          </PageHeader>

          <PageSection>
            <h3 className="my-4">Outreach Reports</h3>
            <AccordionContainer>
              <Accordion
                defaultOpen={true}
                title={<>{<QesIcon isDecorative iconName={QesIcons.FontAwesome.UserMd} width="11" height="14" classNames="align-baseline mr-1" svgStyle={{ position: "relative", top: "1px" }} />}{`Outreach Data (${this.formatExportType(this.state.exportType)})`}</>}
                testId="export-outreach-data__outreach-data-accordion"
              >
                <OutreachDataPanelBody
                  onGenerateClick={this.handleGenerateClick}
                  onToastLeave={this.handleToastLeave}
                  history={this.props.history}
                  location={this.props.location}
                  match={this.props.match}
                  user={this.props.user}
                  activeExportType={this.state.exportType} />
              </Accordion>
            </AccordionContainer>
          </PageSection>
        </PageInner>
      </Page>
    );
  }


  private handleGenerateClick = () => {
    this.setState({ reportGenerating: true });
  }

  private handleToastLeave = () => {
    this.setState({ reportGenerating: false })
  }

  private extractRouteState: () => RouteState = () => {
    const routeState = (this.props.location.state || {}) as RouteState;

    return {
      exportType: routeState.exportType
    } as RouteState;
  }

  private formatExportType = (exportType: string) => {
    return exportType
      .split("-")
      .filter(x => x.length > 0)
      .map((x) => (x.charAt(0).toUpperCase() + x.slice(1)))
      .join(" ");
  }
}

const WrappedExportDataProps = withUserContext(ExportOutreachData);

export {
  WrappedExportDataProps as ExportOutreachData,
  ExportOutreachDataProps,
};